export const P0003600TypeFonctionHorsGelEnum = [
  { ref: 0, label: 'P0003600.status.FunctionHorsGel.0' },
  { ref: 1, label: 'P0003600.status.FunctionHorsGel.1' },
];
